"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextWithSyllabification = _interopRequireDefault(require("../../../SIA-WEBSITE/TextWithSyllabification/TextWithSyllabification"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
var _reactRouterDom = require("react-router-dom");
var _DownloadLinkBox = _interopRequireDefault(require("../../../SIA-WEBSITE/DownloadLinkBox/DownloadLinkBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-organisation-newsletter .events {\n  max-width: 608px;\n  height: min-content; }\n  .sia-organisation-newsletter .events .title {\n    font-size: 26px;\n    line-height: 1.23; }\n  .sia-organisation-newsletter .events img {\n    width: 100%;\n    max-height: 288px;\n    object-fit: cover; }\n\n@media (max-width: 42rem) {\n  .sia-organisation-newsletter .events {\n    width: 100%; } }\n";
  const fileName = "Events_Events";
  const element = document.querySelector("style[data-sass-component='Events_Events']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Events = _ref => {
  let {
    items,
    lang,
    agenda_url,
    event_labels
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "events sia-padding-03-top sia-margin-03-bottom sia-border-01-bottom"
  }, items?.map(item => {
    const image = item.pictures_gallery?.length > 0 ? item.pictures_gallery[0][0]?.desktop?.url : null;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: item.id,
      className: "sia-padding-05-bottom sia-margin-03-bottom sia-border-01-bottom sia-padding-02-inline"
    }, image && /*#__PURE__*/_react.default.createElement("img", {
      src: image
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "title sia-text-10 sia-margin-01-top sia-margin-02-bottom"
    }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
      lang: lang
    }, item.title)), /*#__PURE__*/_react.default.createElement("div", {
      className: "sia-text-10 sia-margin-02-top sia-margin-02-bottom"
    }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, null, item.lead)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      className: "link",
      to: `/${lang}/agenda/${item.event_code}`
    }, /*#__PURE__*/_react.default.createElement(_.default, {
      className: "page-action-down-32"
    })));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "container sia-padding-02-left"
  }, /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: [{
      link: {
        original_url: agenda_url || `/agenda`,
        title: event_labels['cms.newsletter.events.agenda.link']
      }
    }],
    lang: lang,
    isCMS: false
  })));
};
var _default = exports.default = Events;